// tslint:disable: max-line-length
import * as React from "react";
import SvgIcon from "material-ui/SvgIcon";

class FindInPage extends React.PureComponent<any, any> {
    render() {
        return (
            <SvgIcon {...this.props}>
                <path d="M14,2H6C4.9,2,4.01,2.9,4.01,4L4,20c0,1.1,0.89,2,1.99,2H18c1.1,0,2-0.9,2-2V8L14,2z M18,17.58l-1.84-1.84 c1.28-1.94,1.07-4.57-0.64-6.28C14.55,8.49,13.28,8,12,8c-1.28,0-2.55,0.49-3.53,1.46c-1.95,1.95-1.95,5.11,0,7.05 c0.97,0.97,2.25,1.46,3.53,1.46c0.96,0,1.92-0.28,2.75-0.83L17.6,20L6,20V4h7l5,5V17.58z M14.99,12.99c0,0.8-0.31,1.55-0.88,2.11 c-0.56,0.56-1.31,0.88-2.11,0.88s-1.55-0.31-2.11-0.88c-0.56-0.56-0.88-1.31-0.88-2.11s0.31-1.55,0.88-2.11S11.2,10,12,10 s1.55,0.31,2.11,0.88C14.68,11.44,14.99,12.19,14.99,12.99z" />
            </SvgIcon>
        );
    }
}

export default FindInPage;
